module.exports = __webpack_public_path__ + "img/s4_img-s.b7533204.png";